import { resolveRequestAuth } from '@/utils/requestAuth';

/**
 * Build auth headers for API requests.
 *
 * Shared across axios interceptor, streaming fetch calls, and any other
 * code that needs to construct authenticated request headers.
 *
 * Credential and workspace selection live in `resolveRequestAuth` so this and
 * the axios interceptor cannot disagree about which session a request uses.
 */
export function getAuthHeaders(): Record<string, string> {
  const headers: Record<string, string> = {
    'Content-Type': 'application/json',
  };

  if (typeof window === 'undefined') return headers;

  const { token, workspaceId } = resolveRequestAuth();

  if (token) {
    headers['Authorization'] = `Bearer ${token}`;
  }

  if (workspaceId) {
    headers['x-workspace-id'] = workspaceId;
  }

  return headers;
}

/**
 * Get the current workspace ID, or null if not set.
 */
export function getWorkspaceId(): string | null {
  if (typeof window === 'undefined') return null;
  return resolveRequestAuth().workspaceId;
}
